import { FEATURE_FLAG_KEYS } from "@/app/types/flag_definitions"

const getCurrentDate = () => {
  const t = new Date()
  const date = ("0" + t.getDate()).slice(-2)
  const month = ("0" + (t.getMonth() + 1)).slice(-2)
  const year = t.getFullYear()
  return `${month}-${date}-${year}`
}

const remap = {
  YTD: "YTD",
  "1YR": "1 year",
  "3YR": "3 years",
  "5YR": "5 years",
  "10Y": "10 years",
  ALL: "Lifetime",
}

// chart from url
const ChartTypes = {
  growth: { name: "Growth", title: "ORGANIC GROWTH" },
  size: { name: "Size", title: "ORGANIC GROWTH RANK" },
  flows: { name: "Flows", title: "NET FLOWS" },
  mktshare: { name: "Mkt Share", title: "NEW FUNDS" },
  fees: { name: "Fees", title: "RETURNS / FLOWS" },
  performance: { name: "Performance", title: "RETURNS / FEES / SALES" },
}

const explorechartFirms = [
  { key: "Growth", value: "Growth", text: "Growth", disabled: false },
  { key: "Size", value: "Size", text: "Size", disabled: false },
  { key: "Flows", value: "Flows", text: "Flows", disabled: false },
  { key: "Mkt Share", value: "Mkt Share", text: "Mkt Share", disabled: false },
  { key: "Fees", value: "Fees", text: "Fees", disabled: true },
  {
    key: "Performance",
    value: "Performance",
    text: "Performance",
    disabled: true,
  },
]

const explorechartFunds = [
  { key: "Growth", value: "Growth", text: "Growth", disabled: false },
  { key: "Size", value: "Size", text: "Size", disabled: false },
  { key: "Flows", value: "Flows", text: "Flows", disabled: false },
  { key: "Mkt Share", value: "Mkt Share", text: "Mkt Share", disabled: false },
  { key: "Fees", value: "Fees", text: "Fees", disabled: false },
  {
    key: "Performance",
    value: "Performance",
    text: "Performance",
    disabled: false,
  },
]

const qtr = [
  { key: "DAY", value: "DAY", text: "DAY" },
  { key: "MTH", value: "MTH", text: "MTH" },
  { key: "QTR", value: "QTR", text: "QTR" },
  { key: "ANN", value: "ANN", text: "ANN" },
]
const calendar = [
  { key: "DayEnd", value: "DayEnd", text: "DayEnd" },
  { key: "MthEnd", value: "MthEnd", text: "MthEnd" },
  { key: "QtrEnd", value: "QtrEnd", text: "QtrEnd" },
  { key: "Calendar", value: "Calendar", text: "Calendar" },
]
const monthEnd = [
  { key: "1MTH", value: "1MTH", text: "1MTH" },
  { key: "3MTH", value: "3MTH", text: "3MTH" },
  { key: "YTD", value: "YTD", text: "YTD" },
  { key: "1YR", value: "1YR", text: "1YR" },
  { key: "3YR", value: "3YR", text: "3YR" },
  { key: "5YR", value: "5YR", text: "5YR" },
  { key: "10Y", value: "10Y", text: "10Y" },
  { key: "ALL", value: "ALL", text: "ALL" },
]
const year = [
  { key: "YTD", value: "YTD", text: "YTD" },
  { key: "1YR", value: "1YR", text: "1YR" },
  { key: "3YR", value: "3YR", text: "3YR" },
  { key: "5YR", value: "5YR", text: "5YR" },
  { key: "10Y", value: "10Y", text: "10Y" },
  { key: "ALL", value: "ALL", text: "ALL" },
]
// (like year[] + more options)
const yearLonger = [
  { key: "YTD", value: "YTD", text: "YTD" },
  { key: "QTR", value: "QTR", text: "QTR" },
  { key: "MTH", value: "MTH", text: "MTH" },
  { key: "1YR", value: "1YR", text: "1YR" },
  { key: "3YR", value: "3YR", text: "3YR" },
  { key: "5YR", value: "5YR", text: "5YR" },
  { key: "10Y", value: "10Y", text: "10Y" },
  { key: "ALL", value: "ALL", text: "ALL" },
  //{ key: "Day", value: "DAY", text: "DAY" },
]
const yearList = [
  { key: "Y2021", value: "2021", text: "2021" },
  { key: "Y2020", value: "2020", text: "2020" },
  { key: "Y2019", value: "2019", text: "2019" },
  { key: "Y2018", value: "2018", text: "2018" },
  { key: "Y2017", value: "2017", text: "2017" },
  { key: "Y2016", value: "2016", text: "2016" },
  { key: "Y2015", value: "2015", text: "2015" },
  { key: "Y2014", value: "2014", text: "2014" },
  { key: "Y2013", value: "2013", text: "2013" },
]
const charts = [
  { img: "/images/graph/Growth.svg", txt: "Organic Growth", name: "Growth" },
  { img: "/images/graph/Size.svg", txt: "Organic Growth Rank", name: "Size" },
  { img: "/images/graph/Flows.svg", txt: "Sales Rate", name: "Flows" },
  {
    img: "/images/graph/mktShare.svg",
    txt: "Sales Rate Rank",
    name: "Mkt Share",
  },
  { img: "/images/graph/Fees.svg", txt: "Redemptions Rate", name: "Fees" },
  {
    img: "/images/graph/Performance.svg",
    txt: "Redemptions Rate Rank",
    name: "Performance",
  },
  {
    img: "/images/graph/Performance.svg",
    txt: "AUM Change",
    name: "Performance",
  },
  {
    img: "/images/graph/Performance.svg",
    txt: "AUM Change Rank",
    name: "Performance",
  },
]

const metrics_order = [
  { name: "organicGrowthPcent", order: 1 },
  { name: "netflow", order: 2 },
  { name: "cumeNetflow", order: 3 },
  { name: "aumChangePcent", order: 4 },
  { name: "aum", order: 5 },
  { name: "avgAum", order: 6 },
  { name: "returnPcent", order: 7 },
  { name: "returnPtile", order: 8 },
  { name: "numFunds", order: 9 },
  { name: "mktSharePcent", order: 10 },
]

const user_menu_options = [
  {
    key: "profile",
    name: "Profile",
    path: "/user/profile",
    flagKey: "",
  },
  {
    key: "preferences",
    name: "Preferences",
    path: "/user/preferences",
    flagKey: "",
  },
  {
    key: "security",
    name: "Security",
    path: "/user/security",
    flagKey: FEATURE_FLAG_KEYS.features.SHOW_SECURITY_PAGE,
  },
  {
    key: "support",
    name: "Support",
    path: "/user/support",
    flagKey: "",
  },
  {
    key: "glossary",
    name: "Glossary",
    path: "/user/glossary",
    flagKey: "",
  },
]

const glossaryAlphabet = [
  "All",
  "0-9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
]

export {
  ChartTypes,
  calendar,
  charts,
  explorechartFirms,
  explorechartFunds,
  getCurrentDate,
  glossaryAlphabet,
  metrics_order,
  monthEnd,
  qtr,
  remap,
  user_menu_options,
  year,
  yearList,
  yearLonger,
}
